<template>
    <b-table
        :fields="fields"
        :items="items"
        responsive
        hover
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        no-local-sorting
        @sort-changed="$emit('sort-changed', $event)"
        @row-clicked="onClickRow"
    >
        <template #cell(license_number)="data">
            <span>{{ data.item.license_number }}</span>
            <span
                v-if="data.item.is_on_greenlists"
                class="greenlists-indicator ml-1"
                v-b-tooltip.hover
                title="On Greenlists"
            >
                G
            </span>
        </template>
        <template #cell(location)="data">
            {{ [data.item.street, data.item.city].filter(Boolean).join(', ') }}
        </template>
        <template #cell(enriched_at)="data">
            {{ formatDate(data.item.enriched_at) }}
        </template>
    </b-table>
</template>

<script>
import moment from "moment";

export default {
    name: "AdminStateLicensesTable",
    props: {
        licenses: Array,
        sortBy: String,
        sortDesc: Boolean,
    },
    data() {
        return {
            fields: [
                {
                    key: "license_number",
                    label: "License",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
                {
                    key: "facility_name",
                    label: "Facility Name",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
                {
                    key: "status",
                    label: "Status",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
                {
                    key: "shared_ownership_count",
                    label: "Shared",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
                {
                    key: "dba_name",
                    label: "MED DBA",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
                {
                    key: "dba.name",
                    label: "Internal DBA",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
                {
                    key: "location",
                    label: "Location",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                },
                {
                    key: "enriched_at",
                    label: "Last Enriched",
                    thClass: "border-top-0",
                    tdClass: "align-middle",
                    sortable: true,
                },
            ],
        };
    },
    computed: {
        items() {
            return this.licenses;
        },
    },
    methods: {
        onClickRow(item) {
            this.$router.push({
                name: 'admin-state-license-detail',
                params: { id: item.id },
            });
        },
        formatDate(dateString) {
            if (!dateString) {
                return "";
            }
            return moment(dateString).format("MM/DD/YYYY");
        },
    },
};
</script>

<style scoped>
::v-deep .table td,
::v-deep .table th {
    padding: 0.4rem 0.5rem;
}

::v-deep .table tbody tr {
    cursor: pointer;
}

.greenlists-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: #28a745;
    color: white;
    border-radius: 50%;
    font-size: 10px;
    font-weight: bold;
    line-height: 1;
}
</style>
